var React = require('react');

function KbdArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 8L4.913 13 4.913 8.856 16 8.856 16 7.144 4.913 7.144 4.913 3z"}));
}

KbdArrowLeft.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdArrowLeft;

KbdArrowLeft.default = KbdArrowLeft;
